<template>
  <div class="list listTm">
    <!-- <div class="listBanner">
      <img class="img_c1" src="../assets/img/banner_img5.jpg" alt="">
    </div> -->

    <!-- banner -->
    <home-banner ref="homeBanner" :height="445"></home-banner>
    <div class="listMain wrap listSjMain" style="margin-top:20px;">
      <div class="listMainBox clearfloat">
        <div class="listMainLeft fl">
            <div class="listSlidHd">
              <div class="pic">
                <img src="../assets/img/zi_left_b.png" alt="">
              </div>
              <div class="title">
                {{slideHdParentName}}
              </div>
              <div class="txt">
                匠心营造 精益求精
              </div>
            </div>
          <div class="listSlid">
            <div class="listSlidList">
              <div class="listSlidList_line" v-for="(item, index) in slideList" :key="index" >
                <div class="listSlidListInner" :class="{on : active  == item.entTChannelUuid}">
                  <a 
                  v-if="item.url && item.url !== ''" 
                  target="_blank" 
                  :href="item.url">
                  {{item.name}}
                  </a>
                  <a 
                    v-if="!item.url || item.url == ''" 
                    :href="item.catalog === 1 ? `/listPage/${item.entTChannelUuid}` : item.catalog === 2 ? `/list/${item.entTChannelUuid}` : `/listPic/${item.entTChannelUuid}`">
                    {{item.name}}
                  </a>
                </div>
                <div class="thirdNav" v-if="item.child.length != 0">
                  <div class="thirdNav_line" v-for="(item1, index1) in item.child" :key="index1"  :class="{on : item1.name == isClickid2}">
                    <a 
                      v-if="item1.url && item1.url !== ''" 
                      target="_blank" 
                      :href="item1.url">
                      {{item1.name}}
                    </a>
                    <a 
                      v-if="!item1.url || item1.url == ''" 
                      :href="item1.catalog === 1 ? `/listPage/${item.entTChannelUuid}` : item1.catalog === 2 ? `/list/${item1.entTChannelUuid}` : `/listPic/${item1.entTChannelUuid}`">
                      {{item1.name}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="listMainRight fr">
          <div class="listWrap">
            <div class="listHd clearfloat">
              <div class="listpot">{{slideHdTitle}}</div>
               <div class="fl listHdGrop">
                <span class="listHdIco"><i class="el-icon-s-home"></i></span> 您当前所在位置：<a href="/">首页</a> > <span v-if="viewSlideHdParent"><a :href="slideHdParentUrl">{{slideHdParentName}}</a> </span> <span v-if="slideHdName2!=''" class="txt">> {{slideHdName2}} </span> <span v-if="isthird" class="txt">> {{slideHdName1}}</span>
              </div>
            </div>
            <div class="listContainer listPicBox">
              <el-row :gutter="30" style="margin:0 0 10px 0;">
                <el-col :span="8" v-for="(item, index) in listData" :key="index" style="padding:0;">
                  <a target="_blank" class="listPicInner" :href="item.url && item.url !== '' ? item.url : `/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                    <div class="listPicImg">
                      <img :src="item.thumb1" alt="">
                    </div>
                    <h3 class="listPicTitle">{{item.title}}</h3>
                    <span class="listPicMore">查看详情</span>
                  </a>
                </el-col>
              </el-row>
              <div class="listPage">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="pageNum"
                  :page-size="pageSize"
                  :total="total"
                  @current-change="currentChange"
                  style="text-align:center;">
                </el-pagination>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import homeBanner from "@/components/banner/bannerFade.vue"
import homeBanner from "@/components/swiper.vue"
import { getChildChannel, getChannelInfo, articles } from '@/api/common'

export default {
  components: {
    homeBanner
  },
  name: 'list',
  data(){
    return {
      slideHdTitle: '',
      viewSlideHdParent: true,
      slideHdParentName: '',
      slideHdParentUrl: '',
      slideHdName: '',
      hdTitle: '',
      hdName: '',
      pageCont: '',
      active: 0,
      slideHd: {
        title: '新闻动态',
      },
      slideList:[],
      pageSize: 9,
      pageNum: 1,
      total: 0,
      listData: [],
      listId: '',
      isthird: false,
      slideHdName2: '',
      isClickid2: '',
    }
  },
  mounted(){
    var _this = this
    _this.active = _this.$route.params.id
    _this.listId = _this.$route.params.id
    // _this.getChildChannel()
    _this.getChannelInfo()
    _this.articles()
  },
  methods: {
    // 查询二级栏目
    getChildChannel(id) {
      var _this = this

      let data = {
        applicationUuid: _this.webId,
        parentUuid: id
      }
      getChildChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.slideList = data
          if (_this.slideList.length) {
            _this.viewSlideHdParent = true
            let url = ''
            if (_this.slideList[0].catalog === 1) {
              url = `/listPage/${_this.slideList[0].entTChannelUuid}`
            } else if (_this.slideList[0].catalog === 2) {
              url = `/list/${_this.slideList[0].entTChannelUuid}`
            } else {
              url = `/listPic/${_this.slideList[0].entTChannelUuid}`
            }
            _this.slideHdParentUrl = url
          } else {
            _this.viewSlideHdParent = false
          }
        }
      })
    },
    getChannelInfo() {
        var _this = this
        let params1 = {
          channelUuid: _this.$route.params.id
        }
        getChannelInfo(params1).then(res => {
          const {
            code,
            data
          } = res
          if (code === 1 && data) {
            if( data.parentUuid=="0" ){
              _this.slideHdTitle = data.name
              _this.slideHdParentName = data.name
              return
            }
            _this.slideHdName1 = data.name
            let params2 = {
              channelUuid: data.parentUuid
            }
            getChannelInfo(params2).then(res => {
              const {
                code,
                data
              } = res
              if (code === 1 && data) {
                if (data.parentUuid == '0') {
                  _this.getChildChannel(data.entTChannelUuid)
                  _this.slideHdParentName = data.name
                  _this.slideHdName2 = _this.slideHdName1
                  _this.slideHdTitle = _this.slideHdName2
                  _this.isthird = false
                } else {
                  _this.isthird = true
                  _this.getChildChannel(data.parentUuid)
                  _this.slideHdName2 = data.name
                  _this.isClickid = data.channelId
                  let params3 = {
                    channelUuid: data.parentUuid
                  }
                  getChannelInfo(params3).then(res => {
                    const {
                      code,
                      data
                    } = res
                    if (code === 1 && data) {
                      _this.slideHdParentName = data.name
                      _this.slideHdTitle = _this.slideHdName1
                      _this.isClickid2 = _this.slideHdName1
                    }
                  })
                }
              }
            })
          }
        })
       
      },
    // 获取列表
    articles() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: _this.$route.params.id,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.listData = data.rows
          _this.total = data.totalRows
        }
      })
    },
    currentChange(e){
      // console.log('e :>> ', e);
      var _this = this
      _this.pageNum = e
      _this.articles()
    }
  }
}
</script>
<style lang="css" scoped>
.listPicBox {
  padding-top: 20px;
  padding-bottom: 20px;
}
.listSlidListInner.on a {
    background-color: #0062b3;
    color: #FFFFFF;
}
.listPicInner {
  display: block;
  text-align: center;
 
  width: 283px;
  height: 315px;
  display: block;
  overflow: hidden;
  margin-left: 20px;
  float: left;
}

.listPicImg {
  height: 200px;
  overflow: hidden;
  margin-bottom: 15px;
}
.listPicImg img {
  width: 100%;
  height: 197px;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
/* .listPicInner:hover img {
  -moz-transform: scale(1.2);
  -webkit-transform: scale(1.2);
  -o-transform: scale(1.2);
  transform: scale(1.2);
} */
.listPicTitle {
  color: #070404;
  height: 30px;
  text-align: center;
  font-size: 13px;
  width: 100%;
  line-height: 18px;
  color: #424242;
  margin: 5px 0;
}

.listPicMore {
  width: 124px;
  border: 1px solid #ec0404;
  line-height: 30px;
  color: #ec0404;
  margin: 10px auto 0 auto;
  display: inline-block;
  padding: 0 12px;
  white-space: nowrap;
  cursor: pointer;
  height: 30px;
  text-align: center;
  font-size: 13px;
}
.listWrap{
  width: 930px;
}
.listHd {
    width: 100%;
    height: 35px;
    border-bottom: 1px solid #d6d6d6;
} 
.listHdGrop{
    width: 700px;
    text-align: right;
    height: 25px;
    line-height: 25px;
    margin-top: 10px;
    float: right;
    font-size: 12px;
    color: #9a9a9a;
}
.listHdGrop a {
    font-size: 12px;
    color: #9a9a9a;
}
.listSlidListInner a:hover {
    color: #fff;
}
.thirdNav_line a:hover {
    color: #fff;
}
.listSlidHd{
 width: 235px;
 height: 230px;
 background-color: #0062b3;
 color: #FFFFFF;
 position: absolute;
 margin-top: -136px;
 z-index: 9999999;
}
.listSlidHd .pic {
 width: 64px;
 height: 73px;
 margin: 26px auto 0px auto;
}
.listSlidHd .title {
 width: 100%;
 height: 54px;
 line-height: 54px;
 text-align: center;
 font-size: 24px;
 margin-top: 4px;
}
.listSlidHd .txt {
 height: 24px;
 line-height: 24px;
 text-align: center;
 font-size: 16px;
 text-align: center;
 color: #97bde1;
 margin-top: 10px;
}

.listHd {
    width: 100%;
    height: 35px;
    border-bottom: 1px solid #d6d6d6;
} 
.listpot{
    width: 200px;
    height: 35px;
    line-height: 35px;
    float: left;
    font-size: 14px;
}
.listSlid{
  width: 235px;
  height: auto;
  margin-top: 100px;
}
.thirdNav .thirdNav_line {
    margin: 0 0 3px 0;
    padding: 0;
    width: 100%;
    height: 30px;
    display: block;
    line-height: 30px;
    text-align: center;
    font-size: 13px;
    /* color: #000; */
    margin-bottom: 3px;
    font-weight: 400;
    background: none;
}
.thirdNav_line a {
    font-size: 14px;
    font-weight: normal;
    text-align: center;
    display: block;
    widows: 235px;
}
.thirdNav_line:hover {
    background-color: #0062b3;
    color: #fff;
}
.thirdNav_line a:hover {
    color: #fff;
}
.listSlidListInner:hover {
    background-color: #0062b3;
    color: #fff;
}
.listSlidListInner a:hover {
    color: #fff;
}
.thirdNav .thirdNav_line.on a{
  background-color: #0062b3;
    color: #fff;
}
</style>